import { NAV_PAGE_LIST } from './constants';
import { getFromStorage } from '../../components/sidebar/utils';

export const getMenuByRules = () => {
	const rules = getFromStorage('rules');

	const array = NAV_PAGE_LIST;

	if (!rules) return array;

	return array.filter(item => {
		const href = item.href;

		const matchingKey = Object.keys(rules).find(
			key => href.includes(key) && (!href.includes('orders_groups') || key === 'orders_groups'),
		);

		return matchingKey && rules[matchingKey].access === true;
	});
};
